"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var __1 = require("../..");
var hooks_1 = require("../../../hooks");
var variables_1 = require("../../../style/variables");
var SidePanelCollapseButton_1 = __importDefault(require("./SidePanelCollapseButton"));
var constants_1 = require("./constants");
var SidePanelBody_1 = __importDefault(require("./SidePanelBody"));
var styles = {
    componentContainer: react_1.css({
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        position: 'absolute',
    }),
    container: react_1.css({
        overflow: 'visible',
        position: 'relative',
        background: "var(" + variables_1.RootColor.White + ")",
        borderRight: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_3 + ")",
        transition: 'all 0.3s ease',
    }),
    sidebarContent: react_1.css({
        position: 'absolute',
        overflowY: 'auto',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    }),
    collapsedContainer: react_1.css({
        width: '24px',
        cursor: 'pointer',
        ':hover': {
            backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
        },
    }),
    hidden: react_1.css({ display: 'none' }),
};
var SidePanel = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'collapsible' : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, children = _a.children, providedCollapsed = _a.collapsed, onCollapsedChanged = _a.onCollapsedChanged, _d = _a.position, position = _d === void 0 ? 'left' : _d, content = _a.content;
    var _e = hooks_1.useControlledState({
        value: providedCollapsed,
        onChange: onCollapsedChanged,
        defaultValue: false,
    }), collapsed = _e[0], setCollapsed = _e[1];
    var expanded = !collapsed;
    var pageContent = (react_1.jsx("div", { css: { flex: 1, overflow: 'auto' } }, children));
    return (react_1.jsx(__1.Flex, { css: styles.componentContainer },
        position === 'right' ? pageContent : null,
        react_1.jsx("div", { css: [
                styles.container,
                { height: '100%' },
                expanded ? react_1.css({ width: constants_1.SIZE_TO_WIDTH[size], padding: '0px' })
                    : styles.collapsedContainer,
            ], onClick: collapsed ? function () { return setCollapsed(false); } : undefined },
            type === 'collapsible' ? (react_1.jsx(SidePanelCollapseButton_1.default, { expanded: expanded, position: position, onClick: function () { return setCollapsed(!collapsed); } })) : null,
            react_1.jsx("div", { css: [
                    styles.sidebarContent,
                    expanded ? undefined : styles.hidden,
                ] }, content)),
        position === 'left' ? pageContent : null));
};
exports.default = Object.assign(SidePanel, { Body: SidePanelBody_1.default });
